import React, { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { ThemeProps } from '@styles/theme';
import { useTheme } from '@mui/material/styles';

import { Box, Tooltip, Typography } from '@mui/material';
import { flex } from '@resources/mixins';
import classNames from 'classnames';
import { messages } from '../components.messages';


type ExecutionModesProps = {
    modes: string[];
    size?: 'small' | 'normal' | 'large';
}

const useStyles = createUseStyles((theme: ThemeProps) => ({
    deviceIcon: {
        paddingRight: theme.spacing(1),
    },
    deviceIconSmall: {
        maxWidth: '28px',
        maxHeight: '28px',
    },
    modesContainer: {
        ...flex('row', 'flex-start', 'center'),
        flexWrap: 'nowrap',
        gap: theme.spacing(1),
        minWidth: 0,
    },

    normal: {
        fontSize: 16,
        backgroundColor: theme.colors.transp_violet,
        fontStyle: 'bold',
        padding: '6px 10px',
        borderRadius: theme.radius,
        fontFamily: theme.font.secondary,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 'fit-content',
        maxWidth: '100%',
        whiteSpace: 'nowrap',

        '&.MuiTypography-root': {
            fontStyle: 'bold',
            lineHeight: 1,
        },
    },
    small: {
        fontSize: 18,
        backgroundColor: theme.colors.transp_violet,
        fontStyle: 'bold',
        padding: '2px 8px',
        borderRadius: 4,
        fontFamily: theme.font.secondary,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 'fit-content',
        whiteSpace: 'nowrap',

        '&.MuiTypography-root': {
            fontWeight: '800',
            fontSize: 16,
        },
    },
}))

export const ExecutionModes: FC<ExecutionModesProps> = props => {
    const theme = useTheme<ThemeProps>();
    const styles = useStyles({ theme });

    const { modes, size } = props;
    const values = messages as Record<string, any>;

    const getDescription = (mode: string) => {
        const title = values[`executionModes.${mode}.title`] || mode;

        return (<Box>
            {size !== 'large' && <Typography variant='subtitle2' style={{ fontWeight: 'bold', fontSize: 13 }}>
                {title}
            </Typography> }
            {values[`executionModes.${mode}.description`] && (
                <Typography variant='body2' style={{ fontSize: 12, marginTop: 4 }}>
                    {values[`executionModes.${mode}.description`]}
                </Typography>
            )}
        </Box>);
    }

    return (
        <span className={styles.modesContainer}>
            {modes.map(mode => (
                <Tooltip key={mode} title={getDescription(mode)} arrow enterDelay={1000}>
                    <Typography className={classNames({
                        [styles.normal]: !size || (size === 'normal' || size === 'large'),
                        [styles.small]: size === 'small',
                    })}>
                        {size === 'large' ? mode : (values[`executionModes.${mode}.initial`] || mode[0])}
                    </Typography>
                </Tooltip>
            ))}
        </span>
    )
}
